import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import Styled from 'styled';

import FourNetsAvatar from 'four-nets/avatar/avatar';
import { displayedName } from 'four-nets/user/utils';

import { AvatarFragment } from './avatar.graphql';
import defaultStyles from './avatar.scss';

export interface Props extends AvatarFragment {
    styles: typeof defaultStyles;
}

class Avatar extends React.PureComponent<Props> {
    render() {
        const { styles, username, socialName, profile } = this.props;

        const userLink = profile && profile.isVendor ? `/catalog/vendor/${username}/` : `/blog/${username}/`;

        return (
            <div className={styles.wrapper}>
                <Link to={userLink}>
                    <FourNetsAvatar style={{ avatar: styles.avatar }} user={this.props} />
                </Link>
                <div className={styles.text}>
                    <Link to={userLink} className={styles.link}>
                        <span className={styles.username}>{displayedName({ username, socialName })}</span>
                    </Link>
                    {profile && profile.county ? (
                        <FormattedMessage id='COUNTY_%(name)s' values={{ name: profile.county.name }}>
                            {msg => <span className={styles.county}>{msg}</span>}
                        </FormattedMessage>
                    ) : null}
                    {profile && profile.age ? (
                        <FormattedMessage id='AVATAR_AGE__%(num)s_YEARS' values={{ num: profile.age }}>
                            {msg => <span className={styles.age}>{msg}</span>}
                        </FormattedMessage>
                    ) : null}
                </div>
            </div>
        );
    }
}

export default Styled(defaultStyles)(Avatar);
